import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { CoreBox } from '@youscience/core';

import ActionButton from '@components/ActionButton';

import { EllipsisTypography } from '@components/EllipsisTypography';
import {
  sxStyles,
  StyledMoreLink,
  StyledLinearSchoolCard,
  StyledInfographicContainer,
} from '@components/LinearSchoolCard/LinearSchoolCard.styles';

export const LinearCardSkeleton = () => {
  return (
    <StyledLinearSchoolCard>
      <CoreBox sx={sxStyles.schoolTitleWrap}>
        <EllipsisTypography sx={sxStyles.schoolTitle} component="div" variant="h5">
          <Stack spacing={1} direction="column">
            <Skeleton variant="rounded" width={340} height={24} />
            <Skeleton variant="rounded" width={340} height={16} />
          </Stack>
        </EllipsisTypography>

        <CoreBox sx={sxStyles.schoolAddressWrap} />
      </CoreBox>

      <StyledInfographicContainer>
        <Skeleton variant="rounded" width={63} height={30} />

        <Skeleton variant="rounded" width={68} height={30} />

        <Skeleton variant="rounded" width={61} height={30} />
      </StyledInfographicContainer>

      <CoreBox sx={sxStyles.actionsWrap}>
        <ActionButton sx={sxStyles.favoriteBtn} variant="text" type="button">
          <Skeleton variant="rounded" width={21} height={20} />
        </ActionButton>

        <StyledMoreLink to="">
          <Skeleton variant="rounded" width={21} height={20} />
        </StyledMoreLink>
      </CoreBox>
    </StyledLinearSchoolCard>
  );
};
